import { render, staticRenderFns } from "./EstruturaUsuario.vue?vue&type=template&id=5c078340&"
import script from "./EstruturaUsuario.vue?vue&type=script&lang=js&"
export * from "./EstruturaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports